const uuidv1 = require('uuid/v1');
const mime = require('mime-types');
import * as firebase from 'firebase/app';

class FileUploader {
  public isUploading = false;
  private _defaultOptions = { withExt: false, folderName: null };
  public onUploadComplete: Function | null = null;

  constructor(private _fb, private _path) {
  }


  upload(blob, opts = {}, uploadProgress?) {
    this.isUploading = true;
    const options = { ...this._defaultOptions, ...opts };
    const fileId = uuidv1();
    const ext = blob.name != null ? blob.name.split('.').pop() : this.resolveExtByBlob(blob);
    const fileName = (options.withExt && ext != null) ? `${fileId}.${ext}` : fileId;
    const path = this.resolveUploadPath(options);
    const fileRef = this._fb.storage().ref(path).child(fileName);

    const uploadTask = fileRef.put(blob);

    return new Promise((resolve, reject) => {
      uploadTask.on('state_changed', (snapshot) => {
        uploadProgress && uploadProgress(snapshot.bytesTransferred/snapshot.totalBytes);
      }, (error) => { 
        reject(error) 
      }, () => {
        uploadTask.snapshot.ref.getDownloadURL()
          .then((source) => {
            resolve({ id: fileId, source });
          })
        if (uploadProgress) { 
          this.isUploading = false;
        }
      });
    })
  }

  resolveExtByBlob(blob) {
    return mime.extension(blob.type);
  }

  private resolveUploadPath(options) {
    if (options && options.folderName) {
      return `${this._path}/${options.folderName}`;
    }
    return this._path;
  }
}

const fileUploader = new FileUploader(firebase, 'files');

export default fileUploader;